import { keysIn } from "ramda";

export const getCategoriesFiltersSection = (key, data) =>
  data[key].map(key => ({
    value: keysIn(key)[0],
    label: keysIn(key)[0],
    sub_items: key
  }));

export const getFiltersSection = (key, data) =>
  data[key].map(value => ({
    value,
    label: value
  }));



// WEBPACK FOOTER //
// ./src/modules/insiders/utils.js